import {useGetUsersByWorkspaceId, useRemoveUsersFromWorkspace, useWorkSpaceRedux} from 'hooks';
import {UserInviteScopeLevelEnum} from 'models';
import {UserListingResponseModel} from 'models/tenant.model';
import {useEffect, useRef, useState} from 'react';
import {useParams} from 'react-router-dom';
import {MembershipBaseSetting, MemberShipBaseSettingHandleComponent, userColumnsRelations} from 'views/settings/common';

export const WorkspaceMemberSetting = () => {
    const [data, setData] = useState<UserListingResponseModel[]>([]);
    const {workspaceId} = useParams();
    const {selectedWorkSpace} = useWorkSpaceRedux();
    const [selectedIds, setSelectedIds] = useState<string[]>([]);
    const [isAllSelected, setIsAllSelected] = useState(false);
    const [searchValue, setSearchValue] = useState<string>('');

    // Apis
    const {usersByWorkspaceId, usersByWorkspaceIdLoading, usersByWorkspaceIdResponse} = useGetUsersByWorkspaceId();

    const {removeUsersFromWorkspace, removeUsersFromWorkspaceLoading, removeUsersFromWorkspaceResponse} =
        useRemoveUsersFromWorkspace();

    //

    const handleSelectAll = (checked: boolean, allIds: string[]) => {
        setIsAllSelected(checked);
        setSelectedIds(checked ? allIds : []);
    };

    const handleRowSelect = (checked: boolean, id: string) => {
        setSelectedIds(prev => (checked ? [...prev, id] : prev.filter(selectedId => selectedId !== id)));
    };

    const handleAllDelelte = (ids: string[]) => {
        setData(prev => prev.filter(x => !ids.includes(x.id)));
    };

    const removeUserHandler = () => {
        if (selectedWorkSpace && selectedIds.length > 0) {
            removeUsersFromWorkspace({
                variables: {
                    request: {
                        workspaceId: selectedWorkSpace.id,
                        userIds: selectedIds,
                    },
                },
            });
        }
    };

    const memberShipBaseRef = useRef<MemberShipBaseSettingHandleComponent>(null);
    const handleEmailInvite = (values: string) => {
        memberShipBaseRef.current?.handleInviteUserEmails([values]);
    };
    const setIsDeleteAlertOpen = (val: boolean, id?: string) => {
        if (id) {
            setSelectedIds([id]);
        }
        if (memberShipBaseRef.current) {
            memberShipBaseRef.current.setAlertOpen(val);
        }
    };
    const columns = userColumnsRelations({
        selectedIds,
        isAllSelected,
        handleSelectAll,
        handleEmailInvite,
        handleRowSelect,
        setIsDeleteAlertOpen,
    });

    const handleRefreshData = () => {
        if (workspaceId || selectedWorkSpace) {
            usersByWorkspaceId({
                variables: {
                    workspaceSlug: workspaceId ?? selectedWorkSpace?.slug ?? '',
                },
            });
        }
    };

    // useEffects
    useEffect(() => {
        if (workspaceId || selectedWorkSpace) {
            usersByWorkspaceId({
                variables: {
                    workspaceSlug: workspaceId ?? selectedWorkSpace?.slug ?? '',
                },
            });
        }
    }, []);

    useEffect(() => {
        if (!usersByWorkspaceIdLoading && usersByWorkspaceIdResponse) {
            setData(usersByWorkspaceIdResponse.nodes);
        }
    }, [usersByWorkspaceIdResponse, usersByWorkspaceIdLoading]);

    useEffect(() => {
        if (!removeUsersFromWorkspaceLoading && removeUsersFromWorkspaceResponse) {
            handleAllDelelte(selectedIds);
            setIsAllSelected(false);
            setSelectedIds([]);
        }
    }, [removeUsersFromWorkspaceLoading, removeUsersFromWorkspaceResponse]);

    if (!workspaceId && !selectedWorkSpace) {
        return null;
    }
    return (
        <>
            {selectedWorkSpace && (
                <MembershipBaseSetting
                    columns={columns}
                    data={data}
                    ref={memberShipBaseRef}
                    handleRefreshData={handleRefreshData}
                    scopeId={selectedWorkSpace.id}
                    scopeLevel={UserInviteScopeLevelEnum.Workspace}
                    removeUserHandler={removeUserHandler}
                    searchValue={searchValue}
                    selectedIds={selectedIds}
                    setSearchValue={setSearchValue}
                />
            )}
        </>
    );
};

export default WorkspaceMemberSetting;
